/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { PropTypes } from 'prop-types'
import { NavLink } from 'react-router-dom'

const NavigationLink = ({ children, toggleNavbar, to, href, className, target, ...props }) => {
  const rel = target === '_blank' ? 'noopener noreferrer' : null

  return (
    <Choose>
      <When condition={to}>
        <NavLink {...props} className={className} to={to} onClick={toggleNavbar}>
          {children}
        </NavLink>
      </When>
      <When condition={href}>
        <a {...props} className={className} onClick={toggleNavbar} href={href} target={target} rel={rel}>
          {children}
        </a>
      </When>
    </Choose>
  )
}

NavigationLink.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({}), PropTypes.string]).isRequired,
  toggleNavbar: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  target: PropTypes.string,
}

export default NavigationLink
